function PawLoader({
  alt = "loading pounce logo",
  animate = true,
  size = 150,
}) {
  const animationClass = animate ? "animate-pulse" : "";
  return (
    <div className="flex items-center justify-center">
      <img
        src="/assets/images/logo.png"
        alt={alt}
        width={size}
        height={size}
        className={animationClass}
        style={{
          animationDuration: "1.5s",
          animationIterationCount: "infinite",
        }}
      />
    </div>
  );
}

export default PawLoader;
